// @ts-nocheck

// import { useEffect, useState } from "react";
import { use, useEffect, useState } from "react";
import { db } from "../db/db";
import { useLiveQuery } from "dexie-react-hooks";
import ActivitySend from "./Data/Activities";
import TasksSend from "./Data/Tasks";
import BodyMapsSend from "./Data/BodyMaps";
import HolidaySend from "./Data/Holidays";
import DebugLog from "./DebugLog";
import AttendanceSend from "./Data/Attendances";

import { API_BASE_URL as publicApiUrl } from "../utils/api";

function DataSend({ id }: any) {
  const [log, setLog] = useState([]);
  const [timer, setTimer] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(Date.now());
    }, 300000);
    return () => clearInterval(interval);
  }, []);

    const incidents = useLiveQuery(async () => {
      return await db.incidents.where("postedSuccessfully").equals(0).toArray();
    });

    const issues = useLiveQuery(async () => {
      return await db.issues.toArray();
    });
  const expenses = useLiveQuery(async () => {
    return await db.expenses.where("postedSuccessfully").equals(0).toArray();
  });

  // Temporary Cludge to fix wrong value in expenses
const expensesToCludge = useLiveQuery(async ()  => await db.expenses
  .filter((expense) => expense.cludgedSuccessfully === undefined)
  .toArray());


  useEffect(() => {
    if (expensesToCludge) {
      expensesToCludge.map((expense) => {
        if (expense.during_or_on_way_to == "2) On Way") {
          const form = new FormData();
          form.append("datetime_logged", expense.id);
          form.append("save_new_record", "true");
          form.append("c", "ltgb2qzc31qn88xor");
          form.append("t", "l5_expense");
          form.append("rdpartyintid_0", expense.id);
          if (id) {
            form.append("logged_by_6", id);
          }
          if (expense.type == "SL") {
            form.append("parent_slsession_0", expense.visitId);
          } else {
            form.append("parent_comout_visit_0", expense.visitId);
          }
          form.append("during_or_on_way_to", "2) Between");
          if (expense.amount_to_claim) {
            form.append("amount_to_claim", expense.amount_to_claim);
          }
          form.append("mileage_or_expanse", expense.mileage_or_expanse);
          if (expense.number_of_miles) {
            form.append("number_of_miles", expense.number_of_miles);
          }
          form.append("reason_0", expense.reason_0);
          form.append("receipt_evidence_etc", expense.receipt_evidence_etc);
          if (expense.form_client_5) {
            form.append("form_client_5", expense.form_client_5);
          }
          if (expense.for_client_5) {
            form.append("for_client_5", expense.for_client_5);
          }
          if (expense.for_sl_0) {
            form.append("for_sl_0", expense.for_sl_0);
          }

          db.expenses.update(expense["id"], {
            cludgedSuccessfully: 1,
          });
          // setLog(form);
          fetch(`${publicApiUrl}/expense`, {
            body: form,
            method: "POST",
          })
            .then((res) => res.json())
            .then(() => {
              db.expenses
                .update(expense["id"], {
                  cludgedSuccessfully: 1,
                })
                .catch((error) => {
                  setLog(error);
                });
            });
        
        }
      });
    }
  }, [expensesToCludge, id, timer]);
  console.table(expensesToCludge);

  useEffect(() => {
    if (incidents?.length > 0) {
      incidents.map((incident) => {
        const body = new URLSearchParams({
          save_new_record: "true",
          c: "ltgb2qzc31qn88xor",
          t: "l3_incident_report",
          rdpartyintid_4: incident["id"],
          for_client_6: incident["clientId"],
          date_of_incident: incident["incidentDate"],
          location_of_incident: incident["location"],
          some_stuff: incident["description"],
          what_action_did_you_take_and_w0: incident["actionTaken"],
          please_provide_full_details_of_: incident["witnessDetails"],
          please_provide_details_of_witne: incident["witnessInformation"],
          reported_by_1: id && id,
          method_of_reporting: "Via Logger App",
          date_issued_was_reported: Date.now(),
          hc_visi_0: incident["type"] == "HC" ? incident["visit"] : "",
          sl_session_8: incident["type"] == "SL" ? incident["visit"] : "",
          com_out_visit_6: incident["type"] == "Com Out" ? incident["visit"] : "",
        }).toString();
        setLog(import.meta.env.PUBLIC_API_URL);
        fetch(`${publicApiUrl}/incident`, {
          body: body,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
          .then((res) => res.json())
          .then(() => {
            db.incidents.update(incident["id"], {
              postedSuccessfully: 1,
            });
          })
          .catch((error) => {
            setLog(error);
          });
      });
    }

    if (issues?.length > 0) {
      issues
        .filter((issue) => !issue.hasOwnProperty("postedSuccessfully"))
        .map((issue) => {
          const body = new URLSearchParams({
            save_new_record: "true",
            c: "ltgb2qzc31qn88xor",
            t: "a5_issue_for_highlight",
            rdpartyintid_1: issue["id"],
            for_client_8: issue["clientId"],
            status_e: "1) Logged",
            logged_by_c: id && id,
            som_estuff: issue["issue"],
            what_action_did_you_take_and_wh: issue["actionTaken"],
            source_a: "2) Logger",
          }).toString();
          fetch(`${publicApiUrl}/issue`, {
            body: body,
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
            .then((res) => res.json())
            .then(() => {
              db.issues
                .update(issue["id"], {
                  postedSuccessfully: 1,
                })
                .catch((error) => {
                  setLog(error);
                });
            });
          setLog(issue);
        });
    }
  }, [incidents, issues, id, timer]);



  useEffect(() => {
    if (expenses) {
      if (expenses?.length > 0) {
        expenses.map((expense) => {
          const form = new FormData();
          form.append("datetime_logged", expense.id);
          form.append("save_new_record", "true");
          form.append("c", "ltgb2qzc31qn88xor");
          form.append("t", "l5_expense");
          form.append("rdpartyintid_0", expense.id);
          if (id) {
            form.append("logged_by_6", id);
          }
          if (expense.type == "SL") {
            form.append("parent_slsession_0", expense.visitId);
          } else {
            form.append("parent_comout_visit_0", expense.visitId);
          }
          form.append("during_or_on_way_to", expense.during_or_on_way_to);
          if (expense.amount_to_claim) {
            form.append("amount_to_claim", expense.amount_to_claim);
          }
          form.append("mileage_or_expanse", expense.mileage_or_expanse);
          if (expense.number_of_miles) {
            form.append("number_of_miles", expense.number_of_miles);
          }
          form.append("reason_0", expense.reason_0);
          form.append("receipt_evidence_etc", expense.receipt_evidence_etc);
          if (expense.form_client_5) {
            form.append("form_client_5", expense.form_client_5);
          }
          if (expense.for_client_5) {
            form.append("for_client_5", expense.for_client_5);
          }
          if (expense.for_sl_0) {
            form.append("for_sl_0", expense.for_sl_0);
          }

          setLog(form);
          fetch(`${publicApiUrl}/expense`, {
            body: form,
            method: "POST",
          })
            .then((res) => res.json())
            .then(() => {
              db.expenses
                .update(expense["id"], {
                  postedSuccessfully: 1,
                })
                .catch((error) => {
                  setLog(error);
                });
            });
        });
      }
    }
  }, [expenses, id, timer]);
  return (
    <>
      <ActivitySend id={id} />
      <AttendanceSend id={id} />
      <TasksSend key={id} id={id} />
      <BodyMapsSend id={id} />
      <HolidaySend id={id} />
    </>
  );
}

export default DataSend;
